<template>
  <div
    class="transparent-background z-40 absolute top-0 left-0 w-full h-full max-h-full"
    @click="() => exit()"
  >
    <div v-if="!!step.name" class="flex flex-col justify-center h-full max-w-4xl mx-auto">
      <div class="uppercase font-title text-center text-white text-lg">
        {{ $t(`tutorial.${kebabCaseName}`) }}
      </div>
      <div class="w-full flex flex-row-reverse">
        <icon name="close" class="cursor-pointer mr-8 -mt-6 text-white" @click.stop="exit" />
      </div>
      <l-card overflow-visible>
        <div class="video-container">
          <iframe
            class="absolute top-0 left-0 w-full h-full"
            width="560"
            height="315"
            :src="step.link"
            title="Tutorial"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; geolocation"
            allowfullscreen
          ></iframe>
        </div>
      </l-card>
    </div>
  </div>
</template>

<script>
import LCard from '@last/core-ui/components/LCard.vue'
import Icon from '@last/core-ui/v3/components/Icon.vue'

export default {
  name: 'TutorialVideo',
  components: {
    LCard,
    Icon
  },
  props: {
    step: {
      type: Object,
      default: null
    }
  },
  methods: {
    exit() {
      const { showVideo, ...cleanQuery } = this.$route.query
      this.$router.replace({ query: cleanQuery })
      this.$emit('close')
    }
  },
  computed: {
    kebabCaseName() {
      return this.step.name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
    }
  }
}
</script>

<style>
.video-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
</style>
